import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=assetValue&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '资产退出',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `在酒店资产交易及证券化领域，许多业主面临资产估值偏离市场、退出通道单一、资本运作效率低下等问题。华美的服务聚焦酒店类不动产的价值重构与金融创新，针对不同持有周期的业主需求，设计涵盖整售、部分股权转让或REITs证券化的多元退出方案；同时引入杠杆优化工具，平衡债务成本与资本回报率。`,
        icons: [
            {
                name: '资产退出',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/13.资产退出.pdf'),
                path: "四库赋能-酒店资管/资产保值增值/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店资管/资产保值增值/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/资产保值增值/数据赋能'),
                path: "四库赋能-酒店资管/资产保值增值/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/资产保值增值/全球案例/全球案例（资产保值增值）.xlsx'),
                path: "四库赋能-酒店资管/资产保值增值/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/资产保值增值/预警问题/预警问题（资产保值增值）.xlsx'),
                path: "四库赋能-酒店资管/资产保值增值/预警问题"
            },
        ]
    }]
}